<template>
    <div class="mt-3">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-header font-weight-bold">
                        Estado General de Calificación
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6" v-for="category in statistics" v-bind:key="category.id">
                                <div class="card shadow-sm">
                                    <div class="card-body">
                                        <h6 class="card-title">
                                            {{ category.name }}
                                        </h6>
                                        <p class="card-text">
                                            Cantidad de proyectos:
                                            {{ category.projects }}
                                        </p>
                                        <p class="card-text">
                                            Avance de calificación:
                                            {{ category.advance }}%
                                        </p>
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" :style="setAdvanceStyle(
                                category.advance
                            )
                                " :aria-valuenow="category.advance
                                " aria-valuemin="0" aria-valuemax="100">
                                                {{ category.advance }}%
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row row mt-3">
            <div class="col-sm-6">
                <div class="card">
                    <div class="card-header font-weight-bold">
                        Permisos del Administrador
                    </div>
                    <div class="card-body">
                        <form v-on:submit.prevent="submitAdminPermissionForm">
                            <div class="px-3 flex-col">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="show_ranking_general"
                                        value="show_ranking_general" v-model="adminPermission.show_ranking_general
                                " :checked="adminPermission.show_ranking_general
                                " />
                                    <label class="custom-control-label" for="show_ranking_general">Mostrar ranking
                                        general a
                                        jurados</label>
                                </div>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="show_ranking_category"
                                        value="show_ranking_category" v-model="adminPermission.show_ranking_category
                                " :checked="adminPermission.show_ranking_category
                                " />
                                    <label class="custom-control-label" for="show_ranking_category">Mostrar ranking por
                                        categoría a
                                        jurados</label>
                                </div>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="show_status_project"
                                        value="show_status_project" v-model="adminPermission.show_status_project
                                " :checked="adminPermission.show_status_project
                                " />
                                    <label class="custom-control-label" for="show_status_project">Mostrar estado del
                                        proyecto a
                                        concursantes</label>
                                </div>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="enable_rating"
                                        value="enable_rating" v-model="adminPermission.enable_rating"
                                        :checked="adminPermission.enable_rating" />
                                    <label class="custom-control-label" for="enable_rating">Habilitar calificaciones a
                                        jurados</label>
                                </div>
                            </div>
                            <button class="btn btn-primary mt-3">
                                Editar Permisos
                            </button>
                        </form>
                    </div>
                </div>
                <button @click="preSortJuries()" :class="{ 'btn-primary': !isPhase1Sorted }" class="btn mt-3"
                    :disabled="isPhase1Sorted">
                    Asignar proyectos fase 1
                </button>

                <button @click="preSortJuriesPhase2()" :class="{ 'btn-primary': !isPhase2Sorted }" class="btn mt-3"
                    :disabled="isPhase2Sorted">
                    Asignar proyectos fase 2
                </button>

                <button @click="preClearProjectJudge()" class="btn btn-outline-danger mt-3">
                    Limpiar sorteos
                </button>

                <button @click="downloadSortJuries()" :class="{ 'btn-primary': isPhase1Sorted }" class="btn mt-3"
                    :disabled="!isPhase1Sorted">
                    Descargar distribución
                </button>
            </div>

            <div class="col-sm-6">
                <div class="card">
                    <div class="card-header font-weight-bold">
                        Clasificación Proyectos
                    </div>
                    <div class="card-body">
                        <div class="d-flex" v-for="(level, idx) in projectLevels" :key="level.id">
                            <label class="col-md-6">{{ level.name }}</label>
                            <label class="mr-3">Crecimiento</label>
                            <div class="custom-control custom-switch col-md-3">
                                <input type="checkbox" class="custom-control-input" :name="`project-level-${level.id}`"
                                    :value="level.is_junior" :id="`project-level-${level.id}`"
                                    v-model="projectLevels[idx].is_junior" v-on:click="setProjectLevel(level.id, idx)"
                                    :checked="level.is_junior" :disabled="editProjectLevels" />
                                <label class="custom-control-label" :for="`project-level-${level.id}`">Evolución</label>
                            </div>
                        </div>
                    </div>
                    <p class="card-text px-4 pb-3" v-if="editProjectLevels">
                        <small class="text-muted">* La Fase 1 de votación ya inició, no puede cambiar los
                            parámetros.</small>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        contestId: Number,
    },
    data() {
        return {
            statistics: [],
            projectLevels: [],
            projectLevelsChecked: {},
            editProjectLevels: false,
            isPhase1Sorted: true,
            isPhase2Sorted: true,
            adminPermission: {
                show_ranking_general: false,
                show_ranking_category: false,
                show_status_project: false,
                enable_rating: false,
            },
            page: 0,
        };
    },
    methods: {
        changeView(page) {
            this.$emit("change", page);
        },

        getModel() {
            const me = this;
            axios
                .get(`/api/sworn_/get-statistics-by-category/${me.contestId}`)
                .then(function (response) {
                    const { data } = response.data;
                    me.statistics = data.statistics;
                    me.adminPermission = data.adminPermission;
                })
                .catch(function (error) {
                    me.showAlert(
                        "error",
                        "Ha ocurrido un error al cargar el monitor del concurso",
                        ""
                    );
                });
        },

        getIsPhase1Sorted() {
            const me = this;
            axios
                .get(`/api/contest/is-sorted/${me.contestId}`)
                .then(function (response) {
                    me.isPhase1Sorted = response?.data?.result?.is_phase_1_sorted ?? false;
                    me.isPhase2Sorted = response?.data?.result?.is_phase_2_sorted ?? false;
                })
                .catch(function (error) {
                    me.showAlert(
                        "error",
                        "Ha ocurrido un error al cargar el monitor del concurso",
                        ""
                    );
                });
        },

        getProjectLevels() {
            const me = this;
            axios
                .get(`/api/projects/levels/${me.contestId}`)
                .then(function (response) {
                    const { data } = response.data;
                    me.projectLevels = data.project_levels;
                    me.editProjectLevels = !data.can_edit;
                })
                .catch(function (error) { })
                .finally(() => { });
        },

        updateProjectLevel(levelId, idx) {
            const me = this;
            axios
                .put(`/api/projects/levels/${levelId}`, {
                    is_junior: me.projectLevels[idx].is_junior,
                })
                .then(function (response) {
                    me.showActionSuccess("Actualizacion exitosa!");
                })
                .catch(function (error) {
                    me.showAlert(
                        "error",
                        "Ha ocurrido un error al actualizar la clasificación de proyectos",
                        ""
                    );
                })
                .finally(() => { });
        },

        setProjectLevel(levelId, idx) {
            setTimeout(() => this.updateProjectLevel(levelId, idx), 1000);
        },

        setAdvanceStyle(advancePercentage) {
            return `width: ${advancePercentage}%`;
        },

        submitAdminPermissionForm() {
            const me = this;
            me.loading();
            axios
                .put(
                    `/api/contests/update/${me.contestId}`,
                    this.adminPermission
                )
                .then((res) => {
                    me.showActionSuccess("Actualizacion exitosa!");
                })
                .catch((error) => {
                    me.showAlert(
                        "error",
                        "Ha ocurrido un error al actualizar los permisos",
                        ""
                    );
                })
                .finally(() => {
                    me.closeLoading();
                });
        },

        preSortJuries() {
            let me = this;
            this.$swal({
                title: "Esta seguro?",
                text: "No podra revertir este cambio!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "Cancelar",
                confirmButtonText: "Acepto",
            }).then((result) => {
                if (result.value) {
                    me.sortJuries()
                }
            });
        },

        preClearProjectJudge() {
            let me = this;
            this.$swal({
                title: "¿Está seguro?",
                text: "Se eliminarán todos los sorteos del concurso. No podrá revertir este cambio.",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                cancelButtonText: "Cancelar",
                confirmButtonText: "Sí, limpiar",
            }).then((result) => {
                if (result.value) {
                    me.clearProjectJudge();
                }
            });
        },

        clearProjectJudge() {
            const me = this;
            me.loading();
            axios
                .delete(`/api/contests/project-judge/${me.contestId}`)
                .then(() => {
                    me.showActionSuccess("Sorteos eliminados correctamente.");
                    me.isPhase1Sorted = false;
                    me.isPhase2Sorted = false;
                })
                .catch((error) => {
                    console.log(error);
                    me.showAlert(
                        "error",
                        "Ha ocurrido un error al limpiar los sorteos",
                        ""
                    );
                })
                .finally(() => {
                    me.closeLoading();
                });
        },

        preSortJuriesPhase2() {
            let me = this;
            this.$swal({
                title: "Esta seguro?",
                text: "No podra revertir este cambio!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "Cancelar",
                confirmButtonText: "Acepto",
            }).then((result) => {
                if (result.value) {
                    me.sortJuriesPhase2();
                }
            });
        },

        downloadSortJuries() {
            window.open("/export-sorted-juries/" + this.contestId);
        },

        sortJuries() {
            const me = this;
            me.loading();
            axios
                .put(
                    `/api/contests/project-judge/sort/${me.contestId}`,
                    this.adminPermission
                )
                .then((res) => {
                    me.showActionSuccess("Actualizacion exitosa!");
                    me.isPhase1Sorted = true;
                })
                .catch((error) => {
                    console.log(error);
                    me.showAlert(
                        "error",
                        "Ha ocurrido un error al asignar los proyectos",
                        ""
                    );
                })
                .finally(() => {
                    me.closeLoading();
                });
        },

        sortJuriesPhase2() {
            const me = this;
            me.loading();
            axios
                .put(`/api/contests/project-judge/sort-phase-2/${me.contestId}`, {})
                .then((res) => {
                    me.showActionSuccess("Actualizacion exitosa!");
                    me.isPhase2Sorted = true;
                })
                .catch((error) => {
                    console.log(error);
                    me.showAlert(
                        "error",
                        "Ha ocurrido un error al asignar los proyectos de fase 2",
                        ""
                    );
                })
                .finally(() => {
                    me.closeLoading();
                });
        },

        loading() {
            this.$swal({
                text: "Procesando su solicitud, un momento por favor...",
                showConfirmButton: false,
                willOpen: () => {
                    this.$swal.showLoading();
                },
            });
        },

        closeLoading() {
            this.$swal.hideLoading();
        },

        showAlert(type, title, text) {
            this.$swal({
                title: title,
                text: text,
                icon: type,
                type: type,
                confirmButtonText: "Aceptar",
            });
        },

        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
    },
    mounted() {
        let me = this;
        me.getModel();
        me.getProjectLevels();
        me.getIsPhase1Sorted();
    },
};
</script>

<style scoped>
.flex-col {
    display: flex;
    flex-direction: column;
    gap: 0.3em;
}

.loading {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
